import { faSearch, type IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { type FC, useState } from "react";
import { useNavigate } from "react-router";

export const SettingsSearch: FC<{
  tiles: { title: string; subTitle: string; href: string; icon: IconDefinition }[];
}> = (props) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const filteredTiles = props.tiles.filter((tile) => {
    const trimmedSearch = search.trim();
    return (
      trimmedSearch === "" ||
      tile.title.toLowerCase().includes(trimmedSearch.toLowerCase()) ||
      tile.subTitle.toLowerCase().includes(trimmedSearch.toLowerCase())
    );
  });

  return (
    <div>
      <div className={""}>
        <input
          className={`mb-4 border-2 border-slate-200 outline-brand-700 text-black rounded-sm text-base font-normal px-3 py-2 mt-1 w-full`}
          type={"search"}
          value={search}
          placeholder={"Zoeken..."}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus={true}
        />
      </div>
      <div className={"grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4"}>
        {filteredTiles.map((t, k) => {
          return (
            <div
              key={k}
              onClick={() => navigate(t.href)}
              className={
                "h-52 px-4 py-3 bg-white text-black  rounded-sm border border-gray-200  flex justify-center flex-col items-stretch text-center hover:bg-slate-100 hover:cursor-pointer"
              }
            >
              <div className={"flex items-center justify-center"}>
                <div
                  className={
                    "h-16 w-16 text-sm font-medium text-brand-600 bg-brand-100 border border-brand-100 rounded-sm mt-4 flex items-center justify-center"
                  }
                >
                  <FontAwesomeIcon icon={t.icon} className={"text-2xl text-brand-800"} />
                </div>
              </div>
              <div className={"text-lg font-medium my-4"}>{t.title}</div>
              <div className={"text-sm opacity-60  h-12"}>{t.subTitle}</div>
            </div>
          );
        })}
      </div>
      {filteredTiles.length === 0 && (
        <div className={""}>
          <div className={"flex flex-col items-center"}>
            <FontAwesomeIcon icon={faSearch} className={"text-4xl"} />
            <h2 className={"text-xl mt-4 mb-2"}>Geen resultaten</h2>
            <h4>Er zijn geen instellingen gevonden voor deze zoekterm.</h4>
          </div>
        </div>
      )}
    </div>
  );
};
